import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busrentalforpicnicinpune() {



  const cardData =
  {
    keyword: 'Bus Rental for Picnic in Pune',
    heading: 'Sanavi Travels: Bus Rental for Picnic in Pune',
    headingDescription: 'Sanavi Travels offers reliable Bus Rental for Picnic in Pune, providing safe, comfortable, and enjoyable transportation for family outings, school trips, friends’ gatherings, and group picnics to popular local destinations. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth rides, and a hassle-free travel experience. With professional drivers, flexible hourly and full-day picnic bus packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Pune including Hinjewadi, Baner, Wakad, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular picnic spots such as Lonavala, Mahabaleshwar, Khandala, Sinhagad Fort, and Pawna Lake. Choose Sanavi Travels for trusted bus rental services for picnics in Pune, delivering comfort, safety, and a memorable outing experience.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s iconic 18th-century fort built by the Peshwas, featuring massive stone walls, grand gateways like Delhi Darwaza, and spacious courtyards. Though partly destroyed by fire, it stands as a symbol of Maratha heritage and valor. The evening light-and-sound show narrates Pune’s royal history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic monument tied to India’s freedom movement, where Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned. It now houses a museum displaying Gandhi’s personal artifacts and documents amidst serene gardens, making it a significant heritage site."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol, adorned with gold ornaments, draws thousands of devotees daily. Ganesh Chaturthi sees grand celebrations, music, and cultural events, highlighting its spiritual and social significance."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, situated on a hilltop near Pune, is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Shivaji Maharaj. Visitors can trek or drive to explore the fort, enjoy scenic Sahyadri views, and savor local delicacies like pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from basalt rock, it features monolithic pillars and a serene sanctum. Despite its urban location, it offers peace, meditation, and a glimpse into ancient craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts including traditional ornaments, musical instruments, and household antiques. The recreated Mastani Mahal is a highlight, offering cultural and historical insights into India’s heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views after climbing 103 steps. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era and includes smaller shrines and a museum."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global center for meditation, wellness therapies, and mindfulness. Spread across landscaped gardens, it attracts visitors seeking relaxation, rejuvenation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With arched bridges, water streams, and manicured lawns, it is perfect for morning walks, family outings, and photography."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot near Pune. Surrounded by hills, it offers scenic views, especially during monsoon. Visitors enjoy picnics, sunset views, and local snacks, making it a favorite weekend destination."
  }
]
,




"services": [
  {
    "name": "Bus Rental for Picnic in Pune",
    "description": "Bus Rental for Picnic in Pune offers spacious, well-maintained buses designed for a seamless and enjoyable picnic experience. Each bus comes with comfortable seating, air-conditioning, and ample luggage space, ensuring a relaxed journey for families, friends, school groups, and corporate teams. Professional chauffeurs handle route planning, traffic management, and group coordination, allowing passengers to enjoy the ride without stress. Ideal for day trips, weekend getaways, and multi-stop excursions, this service emphasizes safety, punctuality, and comfort. Flexible pickup and drop-off points, along with customizable itineraries, make it convenient for any group size or route in and around Pune."
  },
  {
    "name": "Picnic Bus Hire Pune",
    "description": "Picnic Bus Hire Pune provides organized bus services tailored specifically for leisure trips and outdoor excursions. With clean, air-conditioned interiors, reclining seats, and entertainment options, these buses ensure passengers enjoy every moment of the journey. Suitable for families, friends, school trips, and corporate outings, the service includes professional chauffeurs who navigate the best routes and ensure timely arrivals. Flexible booking, easy scheduling, and safety features such as seatbelts and emergency kits make it a reliable choice for group travel. Perfect for scenic routes, hill stations, or local picnic spots around Pune."
  },
  {
    "name": "AC Picnic Bus Pune",
    "description": "AC Picnic Bus Pune delivers a comfortable and refreshing travel experience with fully air-conditioned buses suitable for hot or long-distance trips. The buses are equipped with spacious seating, clean interiors, and adequate storage for picnic supplies. Ideal for family outings, school trips, and corporate leisure tours, this service prioritizes passenger comfort, safety, and convenience. Professional chauffeurs handle city traffic and highway routes efficiently, while flexible pickup and drop-off options accommodate varying schedules. Perfect for both day trips and weekend excursions, ensuring a pleasant and enjoyable journey."
  },
  {
    "name": "Family Picnic Bus Pune",
    "description": "Family Picnic Bus Pune is designed to make group travel for families comfortable, safe, and enjoyable. The buses provide air-conditioned interiors, ample legroom, reclining seats, and sufficient luggage space for all members. Professional drivers focus on smooth driving, safety, and timely arrivals at destinations. This service is ideal for local parks, weekend getaways, or day-long excursions around Pune, ensuring a stress-free experience for parents and children. Flexible scheduling and customizable itineraries allow families to plan trips according to their convenience."
  },
  {
    "name": "School Picnic Bus Pune",
    "description": "School Picnic Bus Pune ensures safe and organized travel for student excursions and educational trips. Buses are equipped with air-conditioning, comfortable seating, and secure storage for bags and supplies. Professional, experienced chauffeurs prioritize student safety and efficient route planning, allowing teachers and staff to focus on managing the group. The service supports half-day, full-day, or multi-day trips, accommodating different school schedules. Ideal for local parks, historical sites, science centers, or weekend trips, ensuring students enjoy a fun and secure travel experience."
  },
  {
    "name": "Corporate Picnic Bus Pune",
    "description": "Corporate Picnic Bus Pune provides reliable transportation for team outings, employee engagement activities, and company retreats. The buses feature air-conditioned cabins, comfortable seating, ample luggage space, and entertainment options for a relaxing journey. Professional drivers ensure safe, timely, and hassle-free travel, allowing employees to focus on team-building and leisure. Flexible scheduling, pick-up and drop-off locations, and multi-stop routes make this service suitable for any corporate group size or event. Perfect for day trips, weekend retreats, and recreational excursions around Pune."
  },
  {
    "name": "Affordable Picnic Bus Pune",
    "description": "Affordable Picnic Bus Pune offers budget-friendly bus rental options for families, friends, schools, and corporate groups without compromising on comfort or safety. The buses are well-maintained, air-conditioned, and equipped with spacious seating and luggage storage. Professional chauffeurs ensure timely arrivals and smooth driving on both city roads and highways. Flexible booking options and customizable itineraries allow groups to plan trips according to their budget and requirements. Ideal for day-long trips, weekend getaways, and local sightseeing in and around Pune."
  },
  {
    "name": "Chauffeur Driven Picnic Bus",
    "description": "Chauffeur Driven Picnic Bus provides a stress-free travel experience with professional drivers handling navigation, traffic, and group coordination. Buses are spacious, air-conditioned, and equipped with comfortable seating and luggage space. Ideal for families, school groups, friends, and corporate outings, the service ensures timely pickups, smooth journeys, and a relaxing environment for all passengers. Flexible itineraries and convenient pickup and drop-off options make it suitable for local trips, day excursions, and weekend getaways around Pune. Safety, comfort, and reliability are the main priorities of this service."
  },
  {
    "name": "Best Picnic Bus Pune",
    "description": "Best Picnic Bus Pune offers top-quality buses with premium interiors, air-conditioning, ample seating, and storage for luggage and picnic essentials. Designed for families, friends, schools, and corporate groups, the service ensures smooth, safe, and enjoyable travel. Experienced chauffeurs manage city and highway driving, traffic conditions, and route planning efficiently. The service supports day trips, weekend outings, and multi-stop excursions, with flexible pickup and drop-off options. Ideal for anyone seeking a high-standard, reliable, and comfortable picnic travel experience in Pune."
  },
  {
    "name": "Pune Picnic Bus Booking",
    "description": "Pune Picnic Bus Booking allows easy and convenient online reservations for buses tailored for picnics and group outings. Users can select bus type, pickup and drop-off locations, travel dates, and preferred itineraries with instant confirmation. Fully air-conditioned buses with professional chauffeurs ensure a comfortable and safe journey. This service is ideal for families, school groups, corporate outings, and friends planning day trips or weekend getaways. Flexible scheduling, multiple bus options, and well-maintained vehicles make booking simple and stress-free."
  },
  {
    "name": "One Day Picnic Bus Pune",
    "description": "One Day Picnic Bus Pune provides organized and reliable bus transport for short, day-long excursions from Pune. Buses are air-conditioned, spacious, and comfortable, with ample luggage space for picnic essentials. Professional chauffeurs ensure punctual pickups, safe travel, and efficient route planning. Suitable for families, friends, school trips, and corporate outings, this service allows groups to enjoy a full day of sightseeing or leisure activities without any travel-related stress. Flexible booking and customizable itineraries ensure convenience for all passengers."
  },
  {
    "name": "Weekend Picnic Bus Pune",
    "description": "Weekend Picnic Bus Pune specializes in providing buses for weekend getaways, leisure trips, and local sightseeing tours. The buses are well-maintained, air-conditioned, and equipped with comfortable seating and luggage space. Professional drivers ensure smooth, safe travel on both city roads and highways. Ideal for families, friends, corporate groups, and school outings, the service offers flexible pickup and drop-off points, multi-stop itineraries, and customizable schedules. This service combines convenience, safety, and comfort for enjoyable weekend excursions."
  },
  {
    "name": "Tourist Picnic Bus Pune",
    "description": "Tourist Picnic Bus Pune offers organized bus travel for sightseeing trips, heritage tours, and scenic picnic spots around Pune. The buses feature air-conditioning, comfortable seating, and ample luggage space for personal items. Professional chauffeurs handle route planning, traffic, and timing, ensuring a smooth and enjoyable journey. Suitable for families, school groups, corporate teams, and friends, this service allows passengers to explore Pune’s attractions with comfort and reliability. Flexible itineraries and customizable schedules enhance the overall tourist experience."
  },
  {
    "name": "Group Picnic Bus Pune",
    "description": "Group Picnic Bus Pune specializes in transporting large groups for leisure trips, outings, and picnic activities. Buses are spacious, air-conditioned, and equipped with comfortable seating and storage for luggage. Professional chauffeurs ensure safe, timely, and coordinated travel for groups of all sizes. Ideal for schools, colleges, corporate teams, friends, and family gatherings, the service supports flexible itineraries and multi-stop routes. Safety, comfort, and punctuality are prioritized to provide a stress-free and enjoyable group travel experience."
  },
  {
    "name": "Local Picnic Bus Pune",
    "description": "Local Picnic Bus Pune delivers convenient bus services for short trips and day-long outings within Pune city. Buses are air-conditioned, clean, and equipped with comfortable seating and luggage space. Professional drivers manage city traffic efficiently, ensuring timely arrivals at picnic destinations. Suitable for families, friends, schools, and corporate groups, the service provides flexible pickup and drop-off locations, customizable itineraries, and a safe, enjoyable travel experience. Perfect for local sightseeing, park visits, and city-based leisure activities."
  }
],
"tableData": [
  ["Bus Rental for Picnic in Pune", "Picnic Bus Hire Pune"],
  ["AC Picnic Bus Pune", "Family Picnic Bus Pune"],
  ["School Picnic Bus Pune", "Corporate Picnic Bus Pune"],
  ["Affordable Picnic Bus Pune", "Chauffeur Driven Picnic Bus"],
  ["Best Picnic Bus Pune", "Pune Picnic Bus Booking"],
  ["One Day Picnic Bus Pune", "Weekend Picnic Bus Pune"],
  ["Tourist Picnic Bus Pune", "Group Picnic Bus Pune"],
  ["Local Picnic Bus Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Rental for Picnic in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rentals for picnics in Pune, perfect for family outings, school trips, and group excursions."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and regularly serviced buses, ensuring a smooth and enjoyable journey for your picnic."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with Pune routes, ensuring safe and timely transportation for picnic trips."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for picnic bus rentals, including fuel, tolls, and driver allowances, with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and any last-minute changes for picnic trips."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized bus rental packages based on your picnic schedule and group size."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel experience for picnic passengers."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for picnic bus rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rentals for picnics in Pune?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable bus rental services for picnics, family outings, and group trips in Pune.'
  },
  {
    question: 'How can I book a bus for a picnic in Pune?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for picnic trips?',
    answer: 'Sanavi Travels provides air-conditioned, spacious, and well-maintained buses suitable for group outings and picnics.'
  },
  {
    question: 'Are drivers experienced with Pune routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with local routes to ensure safe and timely transportation.'
  },
  {
    question: 'Can I rent a bus for a few hours or a full day?',
    answer: 'Absolutely. We offer hourly, half-day, full-day, and custom packages to match your picnic schedule.'
  },
  {
    question: 'Are the buses sanitized before each trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every picnic rental.'
  },
  {
    question: 'Is customer support available during the picnic trip?',
    answer: 'Yes, our 24x7 customer support team is available throughout your picnic bus rental.'
  },
  {
    question: 'What payment options are available for picnic bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is punctual service guaranteed for picnic bus rentals?',
    answer: 'Yes, Sanavi Travels ensures on-time pickups and reliable service for all picnic bus bookings in Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Kulkarni',
    feedback: 'Booked a bus for a picnic in Pune. Comfortable, clean, and the driver was very professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Sharma',
    feedback: 'Excellent service for our group picnic. Smooth ride, spacious bus, and timely support from Sanavi Travels.',
    rating: 5
  }
];


































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Rental for Picnic in Pune - Sanavi Travels",
  "description": "Book buses for picnics in Pune with Sanavi Travels. AC and luxury buses for family trips, school picnics, corporate outings, group travel, weekend getaways, and comfortable chauffeur-driven picnic journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Bus Rental for Picnic in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury buses in Pune for picnics with Sanavi Travels. Perfect for family trips, school picnics, corporate outings, group travel, weekend getaways, and safe chauffeur-driven picnic journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/77.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busrentalforpicnicinpune;